export const FontAwesomeIcons = [
  'fa-american-sign-language-interpreting',
  'fa-assistive-listening-systems',
  'fa-audio-description',
  'fa-blind',
  'fa-braille',
  'fa-closed-captioning',
  'fa-deaf',
  'fa-low-vision',
  'fa-phone-volume',
  'fa-question-circle',
  'fa-sign-language',
  'fa-tty',
  'fa-universal-access',
  'fa-wheelchair',
  'fa-bell',
  'fa-bell-slash',
  'fa-exclamation',
  'fa-exclamation-circle',
  'fa-exclamation-triangle',
  'fa-radiation',
  'fa-radiation-alt',
  'fa-skull-crossbones',
  'fa-cat',
  'fa-crow',
  'fa-dog',
  'fa-dove',
  'fa-dragon',
  'fa-feather',
  'fa-feather-alt',
  'fa-fish',
  'fa-frog',
  'fa-hippo',
  'fa-horse',
  'fa-horse-head',
  'fa-kiwi-bird',
  'fa-otter',
  'fa-paw',
  'fa-spider',
  'fa-angle-double-down',
  'fa-angle-double-left',
  'fa-angle-double-right',
  'fa-angle-double-up',
  'fa-angle-down',
  'fa-angle-left',
  'fa-angle-right',
  'fa-angle-up',
  'fa-arrow-alt-circle-down',
  'fa-arrow-alt-circle-left',
  'fa-arrow-alt-circle-right',
  'fa-arrow-alt-circle-up',
  'fa-arrow-circle-down',
  'fa-arrow-circle-left',
  'fa-arrow-circle-right',
  'fa-arrow-circle-up',
  'fa-arrow-down',
  'fa-arrow-left',
  'fa-arrow-right',
  'fa-arrow-up',
  'fa-arrows-alt',
  'fa-arrows-alt-h',
  'fa-arrows-alt-v',
  'fa-caret-down',
  'fa-caret-left',
  'fa-caret-right',
  'fa-caret-square-down',
  'fa-caret-square-left',
  'fa-caret-square-right',
  'fa-caret-square-up',
  'fa-caret-up',
  'fa-cart-arrow-down',
  'fa-chart-line',
  'fa-chevron-circle-down',
  'fa-chevron-circle-left',
  'fa-chevron-circle-right',
  'fa-chevron-circle-up',
  'fa-chevron-down',
  'fa-chevron-left',
  'fa-chevron-right',
  'fa-chevron-up',
  'fa-cloud-download-alt',
  'fa-cloud-upload-alt',
  'fa-compress-alt',
  'fa-compress-arrows-alt',
  'fa-download',
  'fa-exchange-alt',
  'fa-expand-alt',
  'fa-expand-arrows-alt',
  'fa-external-link-alt',
  'fa-external-link-square-alt',
  'fa-hand-point-down',
  'fa-hand-point-left',
  'fa-hand-point-right',
  'fa-hand-point-up',
  'fa-hand-pointer',
  'fa-history',
  'fa-level-down-alt',
  'fa-level-up-alt',
  'fa-location-arrow',
  'fa-long-arrow-alt-down',
  'fa-long-arrow-alt-left',
  'fa-long-arrow-alt-right',
  'fa-long-arrow-alt-up',
  'fa-mouse-pointer',
  'fa-play',
  'fa-random',
  'fa-recycle',
  'fa-redo',
  'fa-redo-alt',
  'fa-reply',
  'fa-reply-all',
  'fa-retweet',
  'fa-share',
  'fa-share-square',
  'fa-sign-in-alt',
  'fa-sign-out-alt',
  'fa-sort',
  'fa-sort-alpha-down',
  'fa-sort-alpha-down-alt',
  'fa-sort-alpha-up',
  'fa-sort-alpha-up-alt',
  'fa-sort-amount-down',
  'fa-sort-amount-down-alt',
  'fa-sort-amount-up',
  'fa-sort-amount-up-alt',
  'fa-sort-down',
  'fa-sort-numeric-down',
  'fa-sort-numeric-down-alt',
  'fa-sort-numeric-up',
  'fa-sort-numeric-up-alt',
  'fa-sort-up',
  'fa-sync',
  'fa-sync-alt',
  'fa-text-height',
  'fa-text-width',
  'fa-undo',
  'fa-undo-alt',
  'fa-upload',
  'fa-audio-description',
  'fa-backward',
  'fa-broadcast-tower',
  'fa-circle',
  'fa-closed-captioning',
  'fa-compress',
  'fa-compress-alt',
  'fa-compress-arrows-alt',
  'fa-eject',
  'fa-expand',
  'fa-expand-alt',
  'fa-expand-arrows-alt',
  'fa-fast-backward',
  'fa-fast-forward',
  'fa-file-audio',
  'fa-file-video',
  'fa-film',
  'fa-forward',
  'fa-headphones',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-microphone-alt-slash',
  'fa-microphone-slash',
  'fa-music',
  'fa-pause',
  'fa-pause-circle',
  'fa-phone-volume',
  'fa-photo-video',
  'fa-play',
  'fa-play-circle',
  'fa-podcast',
  'fa-random',
  'fa-redo',
  'fa-redo-alt',
  'fa-rss',
  'fa-rss-square',
  'fa-step-backward',
  'fa-step-forward',
  'fa-stop',
  'fa-stop-circle',
  'fa-sync',
  'fa-sync-alt',
  'fa-tv',
  'fa-undo',
  'fa-undo-alt',
  'fa-video',
  'fa-volume-down',
  'fa-volume-mute',
  'fa-volume-off',
  'fa-volume-up',
  'fa-air-freshener',
  'fa-ambulance',
  'fa-bus',
  'fa-bus-alt',
  'fa-car',
  'fa-car-alt',
  'fa-car-battery',
  'fa-car-crash',
  'fa-car-side',
  'fa-caravan',
  'fa-charging-station',
  'fa-gas-pump',
  'fa-motorcycle',
  'fa-oil-can',
  'fa-shuttle-van',
  'fa-tachometer-alt',
  'fa-taxi',
  'fa-trailer',
  'fa-truck',
  'fa-truck-monster',
  'fa-truck-pickup',
  'fa-apple-alt',
  'fa-campground',
  'fa-cloud-sun',
  'fa-drumstick-bite',
  'fa-football-ball',
  'fa-hiking',
  'fa-mountain',
  'fa-tractor',
  'fa-tree',
  'fa-wind',
  'fa-wine-bottle',
  'fa-beer',
  'fa-blender',
  'fa-cocktail',
  'fa-coffee',
  'fa-flask',
  'fa-glass-cheers',
  'fa-glass-martini',
  'fa-glass-martini-alt',
  'fa-glass-whiskey',
  'fa-mug-hot',
  'fa-wine-bottle',
  'fa-wine-glass',
  'fa-wine-glass-alt',
  'fa-archway',
  'fa-building',
  'fa-campground',
  'fa-church',
  'fa-city',
  'fa-clinic-medical',
  'fa-dungeon',
  'fa-gopuram',
  'fa-home',
  'fa-hospital',
  'fa-hospital-alt',
  'fa-hospital-user',
  'fa-hotel',
  'fa-house-damage',
  'fa-igloo',
  'fa-industry',
  'fa-kaaba',
  'fa-landmark',
  'fa-monument',
  'fa-mosque',
  'fa-place-of-worship',
  'fa-school',
  'fa-store',
  'fa-store-alt',
  'fa-synagogue',
  'fa-torii-gate',
  'fa-university',
  'fa-vihara',
  'fa-warehouse',
  'fa-address-book',
  'fa-address-card',
  'fa-archive',
  'fa-balance-scale',
  'fa-balance-scale-left',
  'fa-balance-scale-right',
  'fa-birthday-cake',
  'fa-book',
  'fa-briefcase',
  'fa-building',
  'fa-bullhorn',
  'fa-bullseye',
  'fa-business-time',
  'fa-calculator',
  'fa-calendar',
  'fa-calendar-alt',
  'fa-chart-area',
  'fa-chart-bar',
  'fa-chart-line',
  'fa-chart-pie',
  'fa-city',
  'fa-clipboard',
  'fa-coffee',
  'fa-columns',
  'fa-compass',
  'fa-copy',
  'fa-copyright',
  'fa-cut',
  'fa-edit',
  'fa-envelope',
  'fa-envelope-open',
  'fa-envelope-square',
  'fa-eraser',
  'fa-fax',
  'fa-file',
  'fa-file-alt',
  'fa-folder',
  'fa-folder-minus',
  'fa-folder-open',
  'fa-folder-plus',
  'fa-glasses',
  'fa-globe',
  'fa-highlighter',
  'fa-industry',
  'fa-landmark',
  'fa-laptop-house',
  'fa-marker',
  'fa-paperclip',
  'fa-paste',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-fancy',
  'fa-pen-nib',
  'fa-pen-square',
  'fa-pencil-alt',
  'fa-percent',
  'fa-phone',
  'fa-phone-alt',
  'fa-phone-slash',
  'fa-phone-square',
  'fa-phone-square-alt',
  'fa-phone-volume',
  'fa-print',
  'fa-project-diagram',
  'fa-registered',
  'fa-save',
  'fa-sitemap',
  'fa-socks',
  'fa-sticky-note',
  'fa-stream',
  'fa-table',
  'fa-tag',
  'fa-tags',
  'fa-tasks',
  'fa-thumbtack',
  'fa-trademark',
  'fa-wallet',
  'fa-binoculars',
  'fa-campground',
  'fa-caravan',
  'fa-compass',
  'fa-faucet',
  'fa-fire',
  'fa-fire-alt',
  'fa-first-aid',
  'fa-frog',
  'fa-hiking',
  'fa-map',
  'fa-map-marked',
  'fa-map-marked-alt',
  'fa-map-signs',
  'fa-mountain',
  'fa-route',
  'fa-toilet-paper',
  'fa-trailer',
  'fa-tree',
  'fa-dollar-sign',
  'fa-donate',
  'fa-dove',
  'fa-gift',
  'fa-globe',
  'fa-hand-holding-heart',
  'fa-hand-holding-usd',
  'fa-hand-holding-water',
  'fa-hands-helping',
  'fa-handshake',
  'fa-heart',
  'fa-leaf',
  'fa-parachute-box',
  'fa-piggy-bank',
  'fa-ribbon',
  'fa-seedling',
  'fa-comment',
  'fa-comment-alt',
  'fa-comment-dots',
  'fa-comment-medical',
  'fa-comment-slash',
  'fa-comments',
  'fa-frown',
  'fa-icons',
  'fa-meh',
  'fa-phone',
  'fa-phone-alt',
  'fa-phone-slash',
  'fa-poo',
  'fa-quote-left',
  'fa-quote-right',
  'fa-smile',
  'fa-sms',
  'fa-video',
  'fa-video-slash',
  'fa-chess',
  'fa-chess-bishop',
  'fa-chess-board',
  'fa-chess-king',
  'fa-chess-knight',
  'fa-chess-pawn',
  'fa-chess-queen',
  'fa-chess-rook',
  'fa-square-full',
  'fa-apple-alt',
  'fa-baby',
  'fa-baby-carriage',
  'fa-bath',
  'fa-biking',
  'fa-birthday-cake',
  'fa-cookie',
  'fa-cookie-bite',
  'fa-gamepad',
  'fa-ice-cream',
  'fa-mitten',
  'fa-robot',
  'fa-school',
  'fa-shapes',
  'fa-snowman',
  'fa-graduation-cap',
  'fa-hat-cowboy',
  'fa-hat-cowboy-side',
  'fa-hat-wizard',
  'fa-mitten',
  'fa-shoe-prints',
  'fa-socks',
  'fa-tshirt',
  'fa-user-tie',
  'fa-archive',
  'fa-barcode',
  'fa-bath',
  'fa-bug',
  'fa-code',
  'fa-code-branch',
  'fa-coffee',
  'fa-file',
  'fa-file-alt',
  'fa-file-code',
  'fa-filter',
  'fa-fire-extinguisher',
  'fa-folder',
  'fa-folder-open',
  'fa-keyboard',
  'fa-laptop-code',
  'fa-microchip',
  'fa-project-diagram',
  'fa-qrcode',
  'fa-shield-alt',
  'fa-sitemap',
  'fa-stream',
  'fa-terminal',
  'fa-user-secret',
  'fa-window-close',
  'fa-window-maximize',
  'fa-window-minimize',
  'fa-window-restore',
  'fa-address-book',
  'fa-address-card',
  'fa-american-sign-language-interpreting',
  'fa-assistive-listening-systems',
  'fa-at',
  'fa-bell',
  'fa-bell-slash',
  'fa-bluetooth',
  'fa-bluetooth-b',
  'fa-broadcast-tower',
  'fa-bullhorn',
  'fa-chalkboard',
  'fa-comment',
  'fa-comment-alt',
  'fa-comments',
  'fa-envelope',
  'fa-envelope-open',
  'fa-envelope-square',
  'fa-fax',
  'fa-inbox',
  'fa-language',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-microphone-alt-slash',
  'fa-microphone-slash',
  'fa-mobile',
  'fa-mobile-alt',
  'fa-paper-plane',
  'fa-phone',
  'fa-phone-alt',
  'fa-phone-slash',
  'fa-phone-square',
  'fa-phone-square-alt',
  'fa-phone-volume',
  'fa-rss',
  'fa-rss-square',
  'fa-tty',
  'fa-voicemail',
  'fa-wifi',
  'fa-compact-disc',
  'fa-database',
  'fa-desktop',
  'fa-download',
  'fa-ethernet',
  'fa-hdd',
  'fa-headphones',
  'fa-keyboard',
  'fa-laptop',
  'fa-laptop-house',
  'fa-memory',
  'fa-microchip',
  'fa-mobile',
  'fa-mobile-alt',
  'fa-mouse',
  'fa-plug',
  'fa-power-off',
  'fa-print',
  'fa-satellite',
  'fa-satellite-dish',
  'fa-save',
  'fa-sd-card',
  'fa-server',
  'fa-sim-card',
  'fa-stream',
  'fa-tablet',
  'fa-tablet-alt',
  'fa-tv',
  'fa-upload',
  'fa-brush',
  'fa-drafting-compass',
  'fa-dumpster',
  'fa-hammer',
  'fa-hard-hat',
  'fa-paint-roller',
  'fa-pencil-alt',
  'fa-pencil-ruler',
  'fa-ruler',
  'fa-ruler-combined',
  'fa-ruler-horizontal',
  'fa-ruler-vertical',
  'fa-screwdriver',
  'fa-toolbox',
  'fa-tools',
  'fa-truck-pickup',
  'fa-wrench',
  'fa-dollar-sign',
  'fa-euro-sign',
  'fa-hryvnia',
  'fa-lira-sign',
  'fa-money-bill',
  'fa-money-bill-alt',
  'fa-money-bill-wave',
  'fa-money-bill-wave-alt',
  'fa-money-check',
  'fa-money-check-alt',
  'fa-pound-sign',
  'fa-ruble-sign',
  'fa-rupee-sign',
  'fa-shekel-sign',
  'fa-tenge',
  'fa-won-sign',
  'fa-yen-sign',
  'fa-bell',
  'fa-bell-slash',
  'fa-calendar',
  'fa-calendar-alt',
  'fa-calendar-check',
  'fa-calendar-minus',
  'fa-calendar-plus',
  'fa-calendar-times',
  'fa-clock',
  'fa-hourglass',
  'fa-hourglass-end',
  'fa-hourglass-half',
  'fa-hourglass-start',
  'fa-stopwatch',
  'fa-adjust',
  'fa-bezier-curve',
  'fa-brush',
  'fa-clone',
  'fa-copy',
  'fa-crop',
  'fa-crop-alt',
  'fa-crosshairs',
  'fa-cut',
  'fa-drafting-compass',
  'fa-draw-polygon',
  'fa-edit',
  'fa-eraser',
  'fa-eye',
  'fa-eye-dropper',
  'fa-eye-slash',
  'fa-fill',
  'fa-fill-drip',
  'fa-highlighter',
  'fa-icons',
  'fa-layer-group',
  'fa-magic',
  'fa-marker',
  'fa-object-group',
  'fa-object-ungroup',
  'fa-paint-brush',
  'fa-paint-roller',
  'fa-palette',
  'fa-paste',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-fancy',
  'fa-pen-nib',
  'fa-pencil-alt',
  'fa-pencil-ruler',
  'fa-ruler-combined',
  'fa-ruler-horizontal',
  'fa-ruler-vertical',
  'fa-save',
  'fa-splotch',
  'fa-spray-can',
  'fa-stamp',
  'fa-swatchbook',
  'fa-tint',
  'fa-tint-slash',
  'fa-vector-square',
  'fa-align-center',
  'fa-align-justify',
  'fa-align-left',
  'fa-align-right',
  'fa-bold',
  'fa-border-all',
  'fa-border-none',
  'fa-border-style',
  'fa-clipboard',
  'fa-clone',
  'fa-columns',
  'fa-copy',
  'fa-cut',
  'fa-edit',
  'fa-eraser',
  'fa-file',
  'fa-file-alt',
  'fa-font',
  'fa-glasses',
  'fa-heading',
  'fa-highlighter',
  'fa-i-cursor',
  'fa-icons',
  'fa-indent',
  'fa-italic',
  'fa-link',
  'fa-list',
  'fa-list-alt',
  'fa-list-ol',
  'fa-list-ul',
  'fa-marker',
  'fa-outdent',
  'fa-paper-plane',
  'fa-paperclip',
  'fa-paragraph',
  'fa-paste',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-fancy',
  'fa-pen-nib',
  'fa-pencil-alt',
  'fa-print',
  'fa-quote-left',
  'fa-quote-right',
  'fa-redo',
  'fa-redo-alt',
  'fa-remove-format',
  'fa-reply',
  'fa-reply-all',
  'fa-screwdriver',
  'fa-share',
  'fa-spell-check',
  'fa-strikethrough',
  'fa-subscript',
  'fa-superscript',
  'fa-sync',
  'fa-sync-alt',
  'fa-table',
  'fa-tasks',
  'fa-text-height',
  'fa-text-width',
  'fa-th',
  'fa-th-large',
  'fa-th-list',
  'fa-tools',
  'fa-trash',
  'fa-trash-alt',
  'fa-trash-restore',
  'fa-trash-restore-alt',
  'fa-underline',
  'fa-undo',
  'fa-undo-alt',
  'fa-unlink',
  'fa-wrench',
  'fa-apple-alt',
  'fa-atom',
  'fa-award',
  'fa-bell',
  'fa-bell-slash',
  'fa-book-open',
  'fa-book-reader',
  'fa-chalkboard',
  'fa-chalkboard-teacher',
  'fa-graduation-cap',
  'fa-laptop-code',
  'fa-microscope',
  'fa-music',
  'fa-school',
  'fa-shapes',
  'fa-theater-masks',
  'fa-user-graduate',
  'fa-angry',
  'fa-dizzy',
  'fa-flushed',
  'fa-frown',
  'fa-frown-open',
  'fa-grimace',
  'fa-grin',
  'fa-grin-alt',
  'fa-grin-beam',
  'fa-grin-beam-sweat',
  'fa-grin-hearts',
  'fa-grin-squint',
  'fa-grin-squint-tears',
  'fa-grin-stars',
  'fa-grin-tears',
  'fa-grin-tongue',
  'fa-grin-tongue-squint',
  'fa-grin-tongue-wink',
  'fa-grin-wink',
  'fa-kiss',
  'fa-kiss-beam',
  'fa-kiss-wink-heart',
  'fa-laugh',
  'fa-laugh-beam',
  'fa-laugh-squint',
  'fa-laugh-wink',
  'fa-meh',
  'fa-meh-blank',
  'fa-meh-rolling-eyes',
  'fa-sad-cry',
  'fa-sad-tear',
  'fa-smile',
  'fa-smile-beam',
  'fa-smile-wink',
  'fa-surprise',
  'fa-tired',
  'fa-atom',
  'fa-battery-empty',
  'fa-battery-full',
  'fa-battery-half',
  'fa-battery-quarter',
  'fa-battery-three-quarters',
  'fa-broadcast-tower',
  'fa-burn',
  'fa-charging-station',
  'fa-fan',
  'fa-fire',
  'fa-fire-alt',
  'fa-gas-pump',
  'fa-industry',
  'fa-leaf',
  'fa-lightbulb',
  'fa-plug',
  'fa-poop',
  'fa-power-off',
  'fa-radiation',
  'fa-radiation-alt',
  'fa-seedling',
  'fa-solar-panel',
  'fa-sun',
  'fa-water',
  'fa-wind',
  'fa-archive',
  'fa-clone',
  'fa-copy',
  'fa-cut',
  'fa-file',
  'fa-file-alt',
  'fa-file-archive',
  'fa-file-audio',
  'fa-file-code',
  'fa-file-excel',
  'fa-file-image',
  'fa-file-pdf',
  'fa-file-powerpoint',
  'fa-file-video',
  'fa-file-word',
  'fa-folder',
  'fa-folder-open',
  'fa-paste',
  'fa-photo-video',
  'fa-save',
  'fa-sticky-note',
  'fa-balance-scale',
  'fa-balance-scale-left',
  'fa-balance-scale-right',
  'fa-book',
  'fa-cash-register',
  'fa-chart-line',
  'fa-chart-pie',
  'fa-coins',
  'fa-comment-dollar',
  'fa-comments-dollar',
  'fa-credit-card',
  'fa-donate',
  'fa-file-invoice',
  'fa-file-invoice-dollar',
  'fa-hand-holding-usd',
  'fa-landmark',
  'fa-money-bill',
  'fa-money-bill-alt',
  'fa-money-bill-wave',
  'fa-money-bill-wave-alt',
  'fa-money-check',
  'fa-money-check-alt',
  'fa-percentage',
  'fa-piggy-bank',
  'fa-receipt',
  'fa-stamp',
  'fa-wallet',
  'fa-bicycle',
  'fa-biking',
  'fa-burn',
  'fa-fire-alt',
  'fa-heart',
  'fa-heartbeat',
  'fa-hiking',
  'fa-running',
  'fa-shoe-prints',
  'fa-skating',
  'fa-skiing',
  'fa-skiing-nordic',
  'fa-snowboarding',
  'fa-spa',
  'fa-swimmer',
  'fa-walking',
  'fa-apple-alt',
  'fa-bacon',
  'fa-bone',
  'fa-bread-slice',
  'fa-candy-cane',
  'fa-carrot',
  'fa-cheese',
  'fa-cloud-meatball',
  'fa-cookie',
  'fa-drumstick-bite',
  'fa-egg',
  'fa-fish',
  'fa-hamburger',
  'fa-hotdog',
  'fa-ice-cream',
  'fa-lemon',
  'fa-pepper-hot',
  'fa-pizza-slice',
  'fa-seedling',
  'fa-stroopwafel',
  'fa-apple-alt',
  'fa-carrot',
  'fa-leaf',
  'fa-lemon',
  'fa-pepper-hot',
  'fa-seedling',
  'fa-chess',
  'fa-chess-bishop',
  'fa-chess-board',
  'fa-chess-king',
  'fa-chess-knight',
  'fa-chess-pawn',
  'fa-chess-queen',
  'fa-chess-rook',
  'fa-dice',
  'fa-dice-d20',
  'fa-dice-d6',
  'fa-dice-five',
  'fa-dice-four',
  'fa-dice-one',
  'fa-dice-six',
  'fa-dice-three',
  'fa-dice-two',
  'fa-gamepad',
  'fa-ghost',
  'fa-headset',
  'fa-heart',
  'fa-puzzle-piece',
  'fa-acquisitions-incorporated',
  'fa-book-dead',
  'fa-dice-d20',
  'fa-dice-d6',
  'fa-dragon',
  'fa-dungeon',
  'fa-fist-raised',
  'fa-hat-wizard',
  'fa-penny-arcade',
  'fa-ring',
  'fa-scroll',
  'fa-skull-crossbones',
  'fa-genderless',
  'fa-mars',
  'fa-mars-double',
  'fa-mars-stroke',
  'fa-mars-stroke-h',
  'fa-mars-stroke-v',
  'fa-mercury',
  'fa-neuter',
  'fa-transgender',
  'fa-transgender-alt',
  'fa-venus',
  'fa-venus-double',
  'fa-venus-mars',
  'fa-book-dead',
  'fa-broom',
  'fa-cloud-moon',
  'fa-crow',
  'fa-ghost',
  'fa-hat-wizard',
  'fa-mask',
  'fa-skull-crossbones',
  'fa-spider',
  'fa-toilet-paper',
  'fa-allergies',
  'fa-fist-raised',
  'fa-hand-holding',
  'fa-hand-holding-heart',
  'fa-hand-holding-medical',
  'fa-hand-holding-usd',
  'fa-hand-holding-water',
  'fa-hand-lizard',
  'fa-hand-middle-finger',
  'fa-hand-paper',
  'fa-hand-peace',
  'fa-hand-point-down',
  'fa-hand-point-left',
  'fa-hand-point-right',
  'fa-hand-point-up',
  'fa-hand-pointer',
  'fa-hand-rock',
  'fa-hand-scissors',
  'fa-hand-sparkles',
  'fa-hand-spock',
  'fa-hands',
  'fa-hands-helping',
  'fa-hands-wash',
  'fa-handshake',
  'fa-handshake-alt-slash',
  'fa-handshake-slash',
  'fa-praying-hands',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-ambulance',
  'fa-h-square',
  'fa-heart',
  'fa-heartbeat',
  'fa-hospital',
  'fa-medkit',
  'fa-plus-square',
  'fa-prescription',
  'fa-stethoscope',
  'fa-user-md',
  'fa-wheelchair',
  'fa-candy-cane',
  'fa-carrot',
  'fa-cookie-bite',
  'fa-gift',
  'fa-gifts',
  'fa-glass-cheers',
  'fa-holly-berry',
  'fa-mug-hot',
  'fa-sleigh',
  'fa-snowman',
  'fa-baby-carriage',
  'fa-bath',
  'fa-bed',
  'fa-briefcase',
  'fa-car',
  'fa-cocktail',
  'fa-coffee',
  'fa-concierge-bell',
  'fa-dice',
  'fa-dice-five',
  'fa-door-closed',
  'fa-door-open',
  'fa-dumbbell',
  'fa-glass-martini',
  'fa-glass-martini-alt',
  'fa-hot-tub',
  'fa-hotel',
  'fa-infinity',
  'fa-key',
  'fa-luggage-cart',
  'fa-shower',
  'fa-shuttle-van',
  'fa-smoking',
  'fa-smoking-ban',
  'fa-snowflake',
  'fa-spa',
  'fa-suitcase',
  'fa-suitcase-rolling',
  'fa-swimmer',
  'fa-swimming-pool',
  'fa-tv',
  'fa-umbrella-beach',
  'fa-utensils',
  'fa-wheelchair',
  'fa-wifi',
  'fa-bath',
  'fa-bed',
  'fa-bell',
  'fa-blender',
  'fa-box-tissue',
  'fa-chair',
  'fa-coffee',
  'fa-couch',
  'fa-door-closed',
  'fa-door-open',
  'fa-dungeon',
  'fa-fan',
  'fa-faucet',
  'fa-house-user',
  'fa-laptop-house',
  'fa-lightbulb',
  'fa-plug',
  'fa-pump-soap',
  'fa-shower',
  'fa-sink',
  'fa-snowflake',
  'fa-soap',
  'fa-toilet-paper',
  'fa-toilet-paper-slash',
  'fa-tv',
  'fa-adjust',
  'fa-bolt',
  'fa-camera',
  'fa-camera-retro',
  'fa-chalkboard',
  'fa-clone',
  'fa-compress',
  'fa-compress-arrows-alt',
  'fa-expand',
  'fa-eye',
  'fa-eye-dropper',
  'fa-eye-slash',
  'fa-file-image',
  'fa-film',
  'fa-id-badge',
  'fa-id-card',
  'fa-image',
  'fa-images',
  'fa-photo-video',
  'fa-portrait',
  'fa-sliders-h',
  'fa-tint',
  'fa-award',
  'fa-ban',
  'fa-barcode',
  'fa-bars',
  'fa-beer',
  'fa-bell',
  'fa-bell-slash',
  'fa-blog',
  'fa-bug',
  'fa-bullhorn',
  'fa-bullseye',
  'fa-calculator',
  'fa-calendar',
  'fa-calendar-alt',
  'fa-calendar-check',
  'fa-calendar-minus',
  'fa-calendar-plus',
  'fa-calendar-times',
  'fa-check',
  'fa-check-circle',
  'fa-check-double',
  'fa-check-square',
  'fa-circle',
  'fa-clipboard',
  'fa-clone',
  'fa-cloud',
  'fa-cloud-download-alt',
  'fa-cloud-upload-alt',
  'fa-coffee',
  'fa-cog',
  'fa-cogs',
  'fa-copy',
  'fa-cut',
  'fa-database',
  'fa-dot-circle',
  'fa-download',
  'fa-edit',
  'fa-ellipsis-h',
  'fa-ellipsis-v',
  'fa-envelope',
  'fa-envelope-open',
  'fa-eraser',
  'fa-exclamation',
  'fa-exclamation-circle',
  'fa-exclamation-triangle',
  'fa-external-link-alt',
  'fa-external-link-square-alt',
  'fa-eye',
  'fa-eye-slash',
  'fa-file',
  'fa-file-alt',
  'fa-file-download',
  'fa-file-export',
  'fa-file-import',
  'fa-file-upload',
  'fa-filter',
  'fa-fingerprint',
  'fa-flag',
  'fa-flag-checkered',
  'fa-folder',
  'fa-folder-open',
  'fa-frown',
  'fa-glasses',
  'fa-grip-horizontal',
  'fa-grip-lines',
  'fa-grip-lines-vertical',
  'fa-grip-vertical',
  'fa-hashtag',
  'fa-heart',
  'fa-history',
  'fa-home',
  'fa-i-cursor',
  'fa-info',
  'fa-info-circle',
  'fa-language',
  'fa-magic',
  'fa-marker',
  'fa-medal',
  'fa-meh',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-microphone-slash',
  'fa-minus',
  'fa-minus-circle',
  'fa-minus-square',
  'fa-paste',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-fancy',
  'fa-pencil-alt',
  'fa-plus',
  'fa-plus-circle',
  'fa-plus-square',
  'fa-poo',
  'fa-qrcode',
  'fa-question',
  'fa-question-circle',
  'fa-quote-left',
  'fa-quote-right',
  'fa-redo',
  'fa-redo-alt',
  'fa-reply',
  'fa-reply-all',
  'fa-rss',
  'fa-rss-square',
  'fa-save',
  'fa-screwdriver',
  'fa-search',
  'fa-search-minus',
  'fa-search-plus',
  'fa-share',
  'fa-share-alt',
  'fa-share-alt-square',
  'fa-share-square',
  'fa-shield-alt',
  'fa-sign-in-alt',
  'fa-sign-out-alt',
  'fa-signal',
  'fa-sitemap',
  'fa-sliders-h',
  'fa-smile',
  'fa-sort',
  'fa-sort-alpha-down',
  'fa-sort-alpha-down-alt',
  'fa-sort-alpha-up',
  'fa-sort-alpha-up-alt',
  'fa-sort-amount-down',
  'fa-sort-amount-down-alt',
  'fa-sort-amount-up',
  'fa-sort-amount-up-alt',
  'fa-sort-down',
  'fa-sort-numeric-down',
  'fa-sort-numeric-down-alt',
  'fa-sort-numeric-up',
  'fa-sort-numeric-up-alt',
  'fa-sort-up',
  'fa-star',
  'fa-star-half',
  'fa-sync',
  'fa-sync-alt',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-times',
  'fa-times-circle',
  'fa-toggle-off',
  'fa-toggle-on',
  'fa-tools',
  'fa-trash',
  'fa-trash-alt',
  'fa-trash-restore',
  'fa-trash-restore-alt',
  'fa-trophy',
  'fa-undo',
  'fa-undo-alt',
  'fa-upload',
  'fa-user',
  'fa-user-alt',
  'fa-user-circle',
  'fa-volume-down',
  'fa-volume-mute',
  'fa-volume-off',
  'fa-volume-up',
  'fa-wifi',
  'fa-wrench',
  'fa-box',
  'fa-boxes',
  'fa-clipboard-check',
  'fa-clipboard-list',
  'fa-dolly',
  'fa-dolly-flatbed',
  'fa-hard-hat',
  'fa-pallet',
  'fa-shipping-fast',
  'fa-truck',
  'fa-warehouse',
  'fa-ambulance',
  'fa-anchor',
  'fa-balance-scale',
  'fa-balance-scale-left',
  'fa-balance-scale-right',
  'fa-bath',
  'fa-bed',
  'fa-beer',
  'fa-bell',
  'fa-bell-slash',
  'fa-bicycle',
  'fa-binoculars',
  'fa-birthday-cake',
  'fa-blind',
  'fa-bomb',
  'fa-book',
  'fa-bookmark',
  'fa-briefcase',
  'fa-building',
  'fa-car',
  'fa-coffee',
  'fa-crosshairs',
  'fa-directions',
  'fa-dollar-sign',
  'fa-draw-polygon',
  'fa-eye',
  'fa-eye-slash',
  'fa-fighter-jet',
  'fa-fire',
  'fa-fire-alt',
  'fa-fire-extinguisher',
  'fa-flag',
  'fa-flag-checkered',
  'fa-flask',
  'fa-gamepad',
  'fa-gavel',
  'fa-gift',
  'fa-glass-martini',
  'fa-globe',
  'fa-graduation-cap',
  'fa-h-square',
  'fa-heart',
  'fa-heartbeat',
  'fa-helicopter',
  'fa-home',
  'fa-hospital',
  'fa-image',
  'fa-images',
  'fa-industry',
  'fa-info',
  'fa-info-circle',
  'fa-key',
  'fa-landmark',
  'fa-layer-group',
  'fa-leaf',
  'fa-lemon',
  'fa-life-ring',
  'fa-lightbulb',
  'fa-low-vision',
  'fa-magnet',
  'fa-male',
  'fa-map',
  'fa-map-marker',
  'fa-map-marker-alt',
  'fa-map-pin',
  'fa-map-signs',
  'fa-medkit',
  'fa-money-bill',
  'fa-money-bill-alt',
  'fa-motorcycle',
  'fa-music',
  'fa-newspaper',
  'fa-parking',
  'fa-paw',
  'fa-phone',
  'fa-phone-alt',
  'fa-phone-square',
  'fa-phone-square-alt',
  'fa-phone-volume',
  'fa-plane',
  'fa-plug',
  'fa-plus',
  'fa-plus-square',
  'fa-print',
  'fa-recycle',
  'fa-restroom',
  'fa-road',
  'fa-rocket',
  'fa-route',
  'fa-search',
  'fa-search-minus',
  'fa-search-plus',
  'fa-ship',
  'fa-shoe-prints',
  'fa-shopping-bag',
  'fa-shopping-basket',
  'fa-shower',
  'fa-snowplow',
  'fa-street-view',
  'fa-subway',
  'fa-suitcase',
  'fa-tag',
  'fa-tags',
  'fa-taxi',
  'fa-thumbtack',
  'fa-ticket-alt',
  'fa-tint',
  'fa-traffic-light',
  'fa-train',
  'fa-tram',
  'fa-tree',
  'fa-trophy',
  'fa-truck',
  'fa-tty',
  'fa-umbrella',
  'fa-university',
  'fa-utensil-spoon',
  'fa-utensils',
  'fa-vest',
  'fa-vest-patches',
  'fa-wheelchair',
  'fa-wifi',
  'fa-wine-glass',
  'fa-wrench',
  'fa-anchor',
  'fa-binoculars',
  'fa-compass',
  'fa-dharmachakra',
  'fa-frog',
  'fa-ship',
  'fa-skull-crossbones',
  'fa-swimmer',
  'fa-water',
  'fa-wind',
  'fa-ad',
  'fa-bullhorn',
  'fa-bullseye',
  'fa-comment-dollar',
  'fa-comments-dollar',
  'fa-envelope-open-text',
  'fa-funnel-dollar',
  'fa-lightbulb',
  'fa-mail-bulk',
  'fa-poll',
  'fa-poll-h',
  'fa-search-dollar',
  'fa-search-location',
  'fa-calculator',
  'fa-divide',
  'fa-equals',
  'fa-greater-than',
  'fa-greater-than-equal',
  'fa-infinity',
  'fa-less-than',
  'fa-less-than-equal',
  'fa-minus',
  'fa-not-equal',
  'fa-percentage',
  'fa-plus',
  'fa-square-root-alt',
  'fa-subscript',
  'fa-superscript',
  'fa-times',
  'fa-wave-square',
  'fa-allergies',
  'fa-ambulance',
  'fa-bacteria',
  'fa-bacterium',
  'fa-band-aid',
  'fa-biohazard',
  'fa-bone',
  'fa-bong',
  'fa-book-medical',
  'fa-brain',
  'fa-briefcase-medical',
  'fa-burn',
  'fa-cannabis',
  'fa-capsules',
  'fa-clinic-medical',
  'fa-comment-medical',
  'fa-crutch',
  'fa-diagnoses',
  'fa-disease',
  'fa-dna',
  'fa-file-medical',
  'fa-file-medical-alt',
  'fa-file-prescription',
  'fa-first-aid',
  'fa-hand-holding-medical',
  'fa-head-side-cough',
  'fa-head-side-cough-slash',
  'fa-head-side-mask',
  'fa-head-side-virus',
  'fa-heart',
  'fa-heartbeat',
  'fa-hospital',
  'fa-hospital-alt',
  'fa-hospital-symbol',
  'fa-hospital-user',
  'fa-id-card-alt',
  'fa-joint',
  'fa-laptop-medical',
  'fa-lungs',
  'fa-lungs-virus',
  'fa-microscope',
  'fa-mortar-pestle',
  'fa-notes-medical',
  'fa-pager',
  'fa-pills',
  'fa-plus',
  'fa-poop',
  'fa-prescription',
  'fa-prescription-bottle',
  'fa-prescription-bottle-alt',
  'fa-procedures',
  'fa-pump-medical',
  'fa-radiation',
  'fa-radiation-alt',
  'fa-shield-virus',
  'fa-smoking',
  'fa-smoking-ban',
  'fa-star-of-life',
  'fa-stethoscope',
  'fa-syringe',
  'fa-tablets',
  'fa-teeth',
  'fa-teeth-open',
  'fa-thermometer',
  'fa-tooth',
  'fa-user-md',
  'fa-user-nurse',
  'fa-vial',
  'fa-vials',
  'fa-virus',
  'fa-virus-slash',
  'fa-viruses',
  'fa-weight',
  'fa-x-ray',
  'fa-archive',
  'fa-box-open',
  'fa-caravan',
  'fa-couch',
  'fa-dolly',
  'fa-people-carry',
  'fa-route',
  'fa-sign',
  'fa-suitcase',
  'fa-tape',
  'fa-trailer',
  'fa-truck-loading',
  'fa-truck-moving',
  'fa-wine-glass',
  'fa-compact-disc',
  'fa-drum',
  'fa-drum-steelpan',
  'fa-file-audio',
  'fa-guitar',
  'fa-headphones',
  'fa-headphones-alt',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-microphone-alt-slash',
  'fa-microphone-slash',
  'fa-music',
  'fa-play',
  'fa-record-vinyl',
  'fa-sliders-h',
  'fa-volume-down',
  'fa-volume-mute',
  'fa-volume-off',
  'fa-volume-up',
  'fa-ambulance',
  'fa-anchor',
  'fa-archive',
  'fa-award',
  'fa-baby-carriage',
  'fa-balance-scale',
  'fa-balance-scale-left',
  'fa-balance-scale-right',
  'fa-bath',
  'fa-bed',
  'fa-beer',
  'fa-bell',
  'fa-bicycle',
  'fa-binoculars',
  'fa-birthday-cake',
  'fa-blender',
  'fa-bomb',
  'fa-book',
  'fa-book-dead',
  'fa-bookmark',
  'fa-briefcase',
  'fa-broadcast-tower',
  'fa-bug',
  'fa-building',
  'fa-bullhorn',
  'fa-bullseye',
  'fa-bus',
  'fa-calculator',
  'fa-calendar',
  'fa-calendar-alt',
  'fa-camera',
  'fa-camera-retro',
  'fa-candy-cane',
  'fa-car',
  'fa-carrot',
  'fa-church',
  'fa-clipboard',
  'fa-cloud',
  'fa-coffee',
  'fa-cog',
  'fa-cogs',
  'fa-compass',
  'fa-cookie',
  'fa-cookie-bite',
  'fa-copy',
  'fa-cube',
  'fa-cubes',
  'fa-cut',
  'fa-dice',
  'fa-dice-d20',
  'fa-dice-d6',
  'fa-dice-five',
  'fa-dice-four',
  'fa-dice-one',
  'fa-dice-six',
  'fa-dice-three',
  'fa-dice-two',
  'fa-digital-tachograph',
  'fa-door-closed',
  'fa-door-open',
  'fa-drum',
  'fa-drum-steelpan',
  'fa-envelope',
  'fa-envelope-open',
  'fa-eraser',
  'fa-eye',
  'fa-eye-dropper',
  'fa-fax',
  'fa-feather',
  'fa-feather-alt',
  'fa-fighter-jet',
  'fa-file',
  'fa-file-alt',
  'fa-file-prescription',
  'fa-film',
  'fa-fire',
  'fa-fire-alt',
  'fa-fire-extinguisher',
  'fa-flag',
  'fa-flag-checkered',
  'fa-flask',
  'fa-futbol',
  'fa-gamepad',
  'fa-gavel',
  'fa-gem',
  'fa-gift',
  'fa-gifts',
  'fa-glass-cheers',
  'fa-glass-martini',
  'fa-glass-whiskey',
  'fa-glasses',
  'fa-globe',
  'fa-graduation-cap',
  'fa-guitar',
  'fa-hat-wizard',
  'fa-hdd',
  'fa-headphones',
  'fa-headphones-alt',
  'fa-headset',
  'fa-heart',
  'fa-heart-broken',
  'fa-helicopter',
  'fa-highlighter',
  'fa-holly-berry',
  'fa-home',
  'fa-hospital',
  'fa-hourglass',
  'fa-igloo',
  'fa-image',
  'fa-images',
  'fa-industry',
  'fa-key',
  'fa-keyboard',
  'fa-laptop',
  'fa-leaf',
  'fa-lemon',
  'fa-life-ring',
  'fa-lightbulb',
  'fa-lock',
  'fa-lock-open',
  'fa-magic',
  'fa-magnet',
  'fa-map',
  'fa-map-marker',
  'fa-map-marker-alt',
  'fa-map-pin',
  'fa-map-signs',
  'fa-marker',
  'fa-medal',
  'fa-medkit',
  'fa-memory',
  'fa-microchip',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-mitten',
  'fa-mobile',
  'fa-mobile-alt',
  'fa-money-bill',
  'fa-money-bill-alt',
  'fa-money-check',
  'fa-money-check-alt',
  'fa-moon',
  'fa-motorcycle',
  'fa-mug-hot',
  'fa-newspaper',
  'fa-paint-brush',
  'fa-paper-plane',
  'fa-paperclip',
  'fa-paste',
  'fa-paw',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-fancy',
  'fa-pen-nib',
  'fa-pencil-alt',
  'fa-phone',
  'fa-phone-alt',
  'fa-plane',
  'fa-plug',
  'fa-print',
  'fa-puzzle-piece',
  'fa-ring',
  'fa-road',
  'fa-rocket',
  'fa-ruler-combined',
  'fa-ruler-horizontal',
  'fa-ruler-vertical',
  'fa-satellite',
  'fa-satellite-dish',
  'fa-save',
  'fa-school',
  'fa-screwdriver',
  'fa-scroll',
  'fa-sd-card',
  'fa-search',
  'fa-shield-alt',
  'fa-shopping-bag',
  'fa-shopping-basket',
  'fa-shower',
  'fa-sim-card',
  'fa-skull-crossbones',
  'fa-sleigh',
  'fa-snowflake',
  'fa-snowplow',
  'fa-space-shuttle',
  'fa-star',
  'fa-sticky-note',
  'fa-stopwatch',
  'fa-stroopwafel',
  'fa-subway',
  'fa-suitcase',
  'fa-sun',
  'fa-tablet',
  'fa-tablet-alt',
  'fa-tachometer-alt',
  'fa-tag',
  'fa-tags',
  'fa-taxi',
  'fa-thumbtack',
  'fa-ticket-alt',
  'fa-toilet',
  'fa-toolbox',
  'fa-tools',
  'fa-train',
  'fa-tram',
  'fa-trash',
  'fa-trash-alt',
  'fa-tree',
  'fa-trophy',
  'fa-truck',
  'fa-tv',
  'fa-umbrella',
  'fa-university',
  'fa-unlock',
  'fa-unlock-alt',
  'fa-utensil-spoon',
  'fa-utensils',
  'fa-wallet',
  'fa-weight',
  'fa-wheelchair',
  'fa-wine-glass',
  'fa-wrench',
  'fa-bell',
  'fa-bookmark',
  'fa-bullhorn',
  'fa-camera',
  'fa-camera-retro',
  'fa-cart-arrow-down',
  'fa-cart-plus',
  'fa-credit-card',
  'fa-gem',
  'fa-gift',
  'fa-handshake',
  'fa-heart',
  'fa-key',
  'fa-money-check',
  'fa-money-check-alt',
  'fa-receipt',
  'fa-shopping-bag',
  'fa-shopping-basket',
  'fa-star',
  'fa-tag',
  'fa-tags',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-trophy',
  'fa-band-aid',
  'fa-book-medical',
  'fa-cannabis',
  'fa-capsules',
  'fa-clinic-medical',
  'fa-disease',
  'fa-eye-dropper',
  'fa-file-medical',
  'fa-file-prescription',
  'fa-first-aid',
  'fa-flask',
  'fa-history',
  'fa-joint',
  'fa-laptop-medical',
  'fa-mortar-pestle',
  'fa-notes-medical',
  'fa-pills',
  'fa-prescription',
  'fa-prescription-bottle',
  'fa-prescription-bottle-alt',
  'fa-receipt',
  'fa-skull-crossbones',
  'fa-syringe',
  'fa-tablets',
  'fa-thermometer',
  'fa-vial',
  'fa-vials',
  'fa-award',
  'fa-balance-scale',
  'fa-balance-scale-left',
  'fa-balance-scale-right',
  'fa-bullhorn',
  'fa-check-double',
  'fa-democrat',
  'fa-donate',
  'fa-dove',
  'fa-fist-raised',
  'fa-flag-usa',
  'fa-handshake',
  'fa-person-booth',
  'fa-piggy-bank',
  'fa-republican',
  'fa-vote-yea',
  'fa-ankh',
  'fa-atom',
  'fa-bahai',
  'fa-bible',
  'fa-church',
  'fa-cross',
  'fa-dharmachakra',
  'fa-dove',
  'fa-gopuram',
  'fa-hamsa',
  'fa-hanukiah',
  'fa-jedi',
  'fa-journal-whills',
  'fa-kaaba',
  'fa-khanda',
  'fa-menorah',
  'fa-mosque',
  'fa-om',
  'fa-pastafarianism',
  'fa-peace',
  'fa-place-of-worship',
  'fa-pray',
  'fa-praying-hands',
  'fa-quran',
  'fa-star-and-crescent',
  'fa-star-of-david',
  'fa-synagogue',
  'fa-torah',
  'fa-torii-gate',
  'fa-vihara',
  'fa-yin-yang',
  'fa-atom',
  'fa-biohazard',
  'fa-brain',
  'fa-burn',
  'fa-capsules',
  'fa-clipboard-check',
  'fa-disease',
  'fa-dna',
  'fa-eye-dropper',
  'fa-filter',
  'fa-fire',
  'fa-fire-alt',
  'fa-flask',
  'fa-frog',
  'fa-magnet',
  'fa-microscope',
  'fa-mortar-pestle',
  'fa-pills',
  'fa-prescription-bottle',
  'fa-radiation',
  'fa-radiation-alt',
  'fa-seedling',
  'fa-skull-crossbones',
  'fa-syringe',
  'fa-tablets',
  'fa-temperature-high',
  'fa-temperature-low',
  'fa-vial',
  'fa-vials',
  'fa-atom',
  'fa-globe',
  'fa-hand-spock',
  'fa-jedi',
  'fa-journal-whills',
  'fa-meteor',
  'fa-moon',
  'fa-robot',
  'fa-rocket',
  'fa-satellite',
  'fa-satellite-dish',
  'fa-space-shuttle',
  'fa-user-astronaut',
  'fa-ban',
  'fa-bug',
  'fa-door-closed',
  'fa-door-open',
  'fa-dungeon',
  'fa-eye',
  'fa-eye-slash',
  'fa-file-contract',
  'fa-file-signature',
  'fa-fingerprint',
  'fa-id-badge',
  'fa-id-card',
  'fa-id-card-alt',
  'fa-key',
  'fa-lock',
  'fa-lock-open',
  'fa-mask',
  'fa-passport',
  'fa-shield-alt',
  'fa-unlock',
  'fa-unlock-alt',
  'fa-user-lock',
  'fa-user-secret',
  'fa-user-shield',
  'fa-bookmark',
  'fa-calendar',
  'fa-circle',
  'fa-cloud',
  'fa-comment',
  'fa-file',
  'fa-folder',
  'fa-heart',
  'fa-heart-broken',
  'fa-map-marker',
  'fa-play',
  'fa-shapes',
  'fa-square',
  'fa-star',
  'fa-barcode',
  'fa-cart-arrow-down',
  'fa-cart-plus',
  'fa-cash-register',
  'fa-gift',
  'fa-gifts',
  'fa-person-booth',
  'fa-receipt',
  'fa-shipping-fast',
  'fa-shopping-bag',
  'fa-shopping-basket',
  'fa-store',
  'fa-store-alt',
  'fa-store-alt-slash',
  'fa-store-slash',
  'fa-truck',
  'fa-tshirt',
  'fa-bell',
  'fa-birthday-cake',
  'fa-camera',
  'fa-comment',
  'fa-comment-alt',
  'fa-envelope',
  'fa-hashtag',
  'fa-heart',
  'fa-icons',
  'fa-image',
  'fa-images',
  'fa-map-marker',
  'fa-map-marker-alt',
  'fa-photo-video',
  'fa-poll',
  'fa-poll-h',
  'fa-retweet',
  'fa-share',
  'fa-share-alt',
  'fa-share-square',
  'fa-star',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-thumbtack',
  'fa-user',
  'fa-user-circle',
  'fa-user-friends',
  'fa-user-plus',
  'fa-users',
  'fa-video',
  'fa-asterisk',
  'fa-atom',
  'fa-bahai',
  'fa-certificate',
  'fa-circle-notch',
  'fa-cog',
  'fa-compact-disc',
  'fa-compass',
  'fa-crosshairs',
  'fa-dharmachakra',
  'fa-fan',
  'fa-life-ring',
  'fa-palette',
  'fa-ring',
  'fa-slash',
  'fa-snowflake',
  'fa-spinner',
  'fa-stroopwafel',
  'fa-sun',
  'fa-sync',
  'fa-sync-alt',
  'fa-yin-yang',
  'fa-baseball-ball',
  'fa-basketball-ball',
  'fa-biking',
  'fa-bowling-ball',
  'fa-dumbbell',
  'fa-football-ball',
  'fa-futbol',
  'fa-golf-ball',
  'fa-hockey-puck',
  'fa-quidditch',
  'fa-running',
  'fa-skating',
  'fa-skiing',
  'fa-skiing-nordic',
  'fa-snowboarding',
  'fa-swimmer',
  'fa-table-tennis',
  'fa-volleyball-ball',
  'fa-allergies',
  'fa-broom',
  'fa-cloud-sun',
  'fa-cloud-sun-rain',
  'fa-frog',
  'fa-rainbow',
  'fa-seedling',
  'fa-umbrella',
  'fa-ban',
  'fa-battery-empty',
  'fa-battery-full',
  'fa-battery-half',
  'fa-battery-quarter',
  'fa-battery-three-quarters',
  'fa-bell',
  'fa-bell-slash',
  'fa-calendar',
  'fa-calendar-alt',
  'fa-calendar-check',
  'fa-calendar-day',
  'fa-calendar-minus',
  'fa-calendar-plus',
  'fa-calendar-times',
  'fa-calendar-week',
  'fa-cart-arrow-down',
  'fa-cart-plus',
  'fa-comment',
  'fa-comment-alt',
  'fa-comment-slash',
  'fa-compass',
  'fa-door-closed',
  'fa-door-open',
  'fa-exclamation',
  'fa-exclamation-circle',
  'fa-exclamation-triangle',
  'fa-eye',
  'fa-eye-slash',
  'fa-file',
  'fa-file-alt',
  'fa-folder',
  'fa-folder-open',
  'fa-gas-pump',
  'fa-info',
  'fa-info-circle',
  'fa-lightbulb',
  'fa-lock',
  'fa-lock-open',
  'fa-map-marker',
  'fa-map-marker-alt',
  'fa-microphone',
  'fa-microphone-alt',
  'fa-microphone-alt-slash',
  'fa-microphone-slash',
  'fa-minus',
  'fa-minus-circle',
  'fa-minus-square',
  'fa-parking',
  'fa-phone',
  'fa-phone-alt',
  'fa-phone-slash',
  'fa-plus',
  'fa-plus-circle',
  'fa-plus-square',
  'fa-print',
  'fa-question',
  'fa-question-circle',
  'fa-shield-alt',
  'fa-sign-in-alt',
  'fa-sign-out-alt',
  'fa-signal',
  'fa-smoking-ban',
  'fa-star',
  'fa-star-half',
  'fa-star-half-alt',
  'fa-stream',
  'fa-thermometer-empty',
  'fa-thermometer-full',
  'fa-thermometer-half',
  'fa-thermometer-quarter',
  'fa-thermometer-three-quarters',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-tint',
  'fa-tint-slash',
  'fa-toggle-off',
  'fa-toggle-on',
  'fa-unlock',
  'fa-unlock-alt',
  'fa-user',
  'fa-user-alt',
  'fa-user-alt-slash',
  'fa-user-slash',
  'fa-video',
  'fa-video-slash',
  'fa-volume-down',
  'fa-volume-mute',
  'fa-volume-off',
  'fa-volume-up',
  'fa-wifi',
  'fa-anchor',
  'fa-biking',
  'fa-fish',
  'fa-hotdog',
  'fa-ice-cream',
  'fa-lemon',
  'fa-sun',
  'fa-swimmer',
  'fa-swimming-pool',
  'fa-umbrella-beach',
  'fa-volleyball-ball',
  'fa-water',
  'fa-bullseye',
  'fa-check-circle',
  'fa-circle',
  'fa-dot-circle',
  'fa-microphone',
  'fa-microphone-slash',
  'fa-star',
  'fa-star-half',
  'fa-star-half-alt',
  'fa-toggle-off',
  'fa-toggle-on',
  'fa-wifi',
  'fa-archway',
  'fa-atlas',
  'fa-bed',
  'fa-bus',
  'fa-bus-alt',
  'fa-caravan',
  'fa-cocktail',
  'fa-concierge-bell',
  'fa-dumbbell',
  'fa-glass-martini',
  'fa-glass-martini-alt',
  'fa-globe-africa',
  'fa-globe-americas',
  'fa-globe-asia',
  'fa-globe-europe',
  'fa-hot-tub',
  'fa-hotel',
  'fa-luggage-cart',
  'fa-map',
  'fa-map-marked',
  'fa-map-marked-alt',
  'fa-monument',
  'fa-passport',
  'fa-plane',
  'fa-plane-arrival',
  'fa-plane-departure',
  'fa-shuttle-van',
  'fa-spa',
  'fa-suitcase',
  'fa-suitcase-rolling',
  'fa-swimmer',
  'fa-swimming-pool',
  'fa-taxi',
  'fa-tram',
  'fa-tv',
  'fa-umbrella-beach',
  'fa-wine-glass',
  'fa-wine-glass-alt',
  'fa-address-book',
  'fa-address-card',
  'fa-baby',
  'fa-bed',
  'fa-biking',
  'fa-blind',
  'fa-chalkboard-teacher',
  'fa-child',
  'fa-female',
  'fa-frown',
  'fa-hiking',
  'fa-id-badge',
  'fa-id-card',
  'fa-id-card-alt',
  'fa-male',
  'fa-meh',
  'fa-people-arrows',
  'fa-people-carry',
  'fa-person-booth',
  'fa-poo',
  'fa-portrait',
  'fa-power-off',
  'fa-pray',
  'fa-restroom',
  'fa-running',
  'fa-skating',
  'fa-skiing',
  'fa-skiing-nordic',
  'fa-smile',
  'fa-snowboarding',
  'fa-street-view',
  'fa-swimmer',
  'fa-user',
  'fa-user-alt',
  'fa-user-alt-slash',
  'fa-user-astronaut',
  'fa-user-check',
  'fa-user-circle',
  'fa-user-clock',
  'fa-user-cog',
  'fa-user-edit',
  'fa-user-friends',
  'fa-user-graduate',
  'fa-user-injured',
  'fa-user-lock',
  'fa-user-md',
  'fa-user-minus',
  'fa-user-ninja',
  'fa-user-nurse',
  'fa-user-plus',
  'fa-user-secret',
  'fa-user-shield',
  'fa-user-slash',
  'fa-user-tag',
  'fa-user-tie',
  'fa-user-times',
  'fa-users',
  'fa-users-cog',
  'fa-users-slash',
  'fa-walking',
  'fa-wheelchair',
  'fa-accessible-icon',
  'fa-ambulance',
  'fa-baby-carriage',
  'fa-bicycle',
  'fa-bus',
  'fa-bus-alt',
  'fa-car',
  'fa-car-alt',
  'fa-car-crash',
  'fa-car-side',
  'fa-fighter-jet',
  'fa-helicopter',
  'fa-horse',
  'fa-motorcycle',
  'fa-paper-plane',
  'fa-plane',
  'fa-rocket',
  'fa-ship',
  'fa-shopping-cart',
  'fa-shuttle-van',
  'fa-sleigh',
  'fa-snowplow',
  'fa-space-shuttle',
  'fa-subway',
  'fa-taxi',
  'fa-tractor',
  'fa-train',
  'fa-tram',
  'fa-truck',
  'fa-truck-monster',
  'fa-truck-pickup',
  'fa-wheelchair',
  'fa-bolt',
  'fa-cloud',
  'fa-cloud-meatball',
  'fa-cloud-moon',
  'fa-cloud-moon-rain',
  'fa-cloud-rain',
  'fa-cloud-showers-heavy',
  'fa-cloud-sun',
  'fa-cloud-sun-rain',
  'fa-meteor',
  'fa-moon',
  'fa-poo-storm',
  'fa-rainbow',
  'fa-smog',
  'fa-snowflake',
  'fa-sun',
  'fa-temperature-high',
  'fa-temperature-low',
  'fa-umbrella',
  'fa-water',
  'fa-wind',
  'fa-glass-whiskey',
  'fa-icicles',
  'fa-igloo',
  'fa-mitten',
  'fa-skating',
  'fa-skiing',
  'fa-skiing-nordic',
  'fa-snowboarding',
  'fa-snowplow',
  'fa-tram',
  'fa-archive',
  'fa-blog',
  'fa-book',
  'fa-bookmark',
  'fa-edit',
  'fa-envelope',
  'fa-envelope-open',
  'fa-eraser',
  'fa-file',
  'fa-file-alt',
  'fa-folder',
  'fa-folder-open',
  'fa-keyboard',
  'fa-newspaper',
  'fa-paper-plane',
  'fa-paperclip',
  'fa-paragraph',
  'fa-pen',
  'fa-pen-alt',
  'fa-pen-square',
  'fa-pencil-alt',
  'fa-quote-left',
  'fa-quote-right',
  'fa-sticky-note',
  'fa-thumbtack',
  'fa-backspace',
  'fa-blender-phone',
  'fa-crown',
  'fa-dumpster-fire',
  'fa-file-csv',
  'fa-font-awesome',
  'fa-font-awesome-flag',
  'fa-font-awesome-logo-full',
  'fa-network-wired',
  'fa-plane-slash',
  'fa-signature',
  'fa-skull',
  'fa-stopwatch-20',
  'fa-vr-cardboard',
  'fa-weight-hanging'
];
